/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Delete_Chat_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Delete chat?" |
*
* @param {Assistant_Delete_Chat_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_delete_chat_confirm_title = /** @type {((inputs?: Assistant_Delete_Chat_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Delete_Chat_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la conversation ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Chat löschen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare la chat?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить чат?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar el chat?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除聊天记录？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チャットを削除しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चैट डिलीट करें?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Apagar chat?")
	return /** @type {LocalizedString} */ ("Delete chat?")
});